export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return "";

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toLocaleDateString("pt-BR", {
    timeZone: "UTC", // Garante que não converta pro fuso local
  });
};
